module.exports = "<mat-slider\n  \n  [invert]=\"invert\"\n  [max]=\"max\"\n  [min]=\"min\"\n  [step]=\"step\"\n  [thumb-label]=\"thumbLabel\"\n  [tick-interval]=\"tickInterval\"\n  [value]=\"value\"\n  [vertical]=\"vertical\"\n  (change)=\"emit($event)\"\n  style=\"margin:0 auto;\"\n  [ngStyle]=\"{'width': width}\">\n</mat-slider>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-slider/br-slider.component.html
// module id = ../../../../../src/app/brds/widgets/br-slider/br-slider.component.html
// module chunks = 10